import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { RootState } from "store";

import MessageCard from "./MessageCard";

const MessagesContent = ({
  conversation,
}: {
  conversation: any;
}): JSX.Element => {
  const { myUserId } = useSelector((state: RootState) => ({
    myUserId: state.auth.user?.merlin_id,
  }));

  const newestMessageRef = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    newestMessageRef.current?.scrollIntoView();
  }, [conversation]);

  return (
    <div className="h-full overflow-auto relative flex-grow overflow-auto px-4">
      {conversation.messages?.map((message) => (
        <MessageCard
          key={message.id}
          conversationId={conversation.id}
          data-test-id={`MessageCard_${message.id}`}
          sentByMe={message.sender.id === myUserId}
          message={message}
        />
      ))}
      <div className="h-10" ref={newestMessageRef} />
    </div>
  );
};

export default MessagesContent;
